import { useEffect, useMemo, useRef, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useMessenger } from "./../../context/MessengerContext";
import { ThemeContext } from "./../../constant/theme";
import { Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";

// Ø§Ù„ØµÙØ­Ø§Øª
import EmployeesTableadmin from "../(admin)employeemanagement/EmployeeManagement.jsx";
import EmployeesTable from "../(Manager)employeemanagement/EmployeeManagementManager";
import Dashboard from "../(Admin) dashboard/index.js";
import Analytics from "../(All) ComingSoon/ComingSoon.js";
import Reports from "../(Admin) Reports/Reports.js";
import Calendar from "../(All) Calendar/index.jsx";
import Attendance from "../(Admin)Attendance";
import SettingsPage from "../(All) settings/settings.js";
import Mo3tiAdminDocumentRequests from "../(Admin)DocumentRequests/DocumentRequestsPage.jsx";
import ExcelSalaryProcessorWithTheme from "../(Admin and Manager) Taxcalculator";
import Payroll from "../(admin and manager) Payroll/index.jsx";
import SidebarWithTopbar from "../(All) Sidebar/SidebarWithTopbar";
import ViewTypeSwitcher from '../../components/ViewTypeSwitcher';
import Mo3tiAdvancementManagement from "../(Admin)AdvancementManagement/AdvancementManagementPage.jsx";
import LeaveApprovalPage from "../(Admin)leave_Managment/index.jsx";
import MessengerPage from "../(All) messenger/MessengerPage.jsx";
import EmployeeActionsPage from "../(Admin)EmployeeActions/EmployeeActionsPage.jsx";
import CompanyConfiguration from "../(SuperAdmin)ConfigurationManagement";
import { LanguageContext } from "../../constant/LanguageContext";
import { useModal } from '../../constant/ModalContext.jsx';
import { translations_Manager } from "../../constant/Admin_Translations.js";
import {
    Home,
    Users,
    CalendarCheck,
    MessageSquare,
    BookCheckIcon,
    Coffee,
    DollarSignIcon,
    GitPullRequestIcon,
    CreditCard,
    CalculatorIcon,
    LockIcon,
    Settings,
    CalendarIcon as CalendarIcon,
    Moon,
    Sun,
    Clock,
} from "lucide-react";

// constants
import { pageToModuleMap, adminOnlyPages } from "./constants/pageToModuleMap";

// hooks
import useLocationAccess from "./hooks/useLocationAccess";
import useModulePermissions from "./hooks/useModulePermissions";
import useUnreadMessages from "./hooks/useUnreadMessages";
import useMetricsFetch from "./hooks/useMetricsFetch";
import useSyncPageWithRoute from "./hooks/useSyncPageWithRoute";

// components
import BackgroundBlobs from "./components/BackgroundBlobs";

// renderers
import { renderCurrentPage } from "./renderers/pageRenderer";

function ProfessionalDashboardManager() {
    // Ø³ÙŠØ§Ù‚ Ø§Ù„Ø«ÙŠÙ…
    const { theme, setTheme } = useContext(ThemeContext);

    // Ø§Ù„Ù„ØºØ© Ø§Ù„Ø­Ø§Ù„ÙŠØ©
    const { language = 'en' } = useContext(LanguageContext);
    const isRTL = language === 'ar';
    const t = translations_Manager[language] || translations_Manager['ar'];

    // hooks
    const { userLocation, locationError } = useLocationAccess(t);

    const [employeeCount, setEmployeeCount] = useState(0);
    const [counts, setCounts] = useState({ Active: 0, OnLeave: 0, Recent: 0, TotalCompanies: 0 });
    const [departmentStats, setDepartmentStats] = useState([]);
    const [viewType, setViewType] = useState(() => {
        return localStorage.getItem('managerViewType') || 'manager';
    });

    useEffect(() => {
        try {
            const storedRole = (localStorage.getItem('role') || '').toLowerCase();
            const adminLevelRaw = localStorage.getItem('adminLevel');
            let hasAdmin = false;

            if (adminLevelRaw) {
                try {
                    const parsed = JSON.parse(adminLevelRaw);
                    hasAdmin = Boolean(
                        parsed?.adminLevelId ||
                        parsed?.admin_level_id ||
                        (Array.isArray(parsed?.modules) && parsed.modules.length > 0)
                    );
                } catch (parseError) {
                    console.warn('Failed to parse admin level during view enforcement:', parseError);
                }
            }

            if (storedRole === 'manager' && !hasAdmin) {
                if (localStorage.getItem('managerViewType') !== 'manager') {
                    localStorage.setItem('managerViewType', 'manager');
                    localStorage.setItem('viewType', 'manager');
                }
                setViewType('manager');
            }
        } catch (error) {
            console.warn('Failed to enforce default manager view:', error);
        }
    }, []);

    // This shell renders different content for viewType 'manager' vs 'admin'
    // without changing the URL (see renderEmployees/navItems below), so a view
    // switch triggered from somewhere else while this page is already mounted
    // (e.g. a notification click that calls applyViewSwitch — see
    // notificationNavigation.js) only reaches this component through this
    // event; without it, viewType would keep showing the value from when this
    // page first mounted even though localStorage — and every other switcher
    // — had already moved on.
    useEffect(() => {
        const syncViewType = () => {
            setViewType(localStorage.getItem('managerViewType') || localStorage.getItem('viewType') || 'manager');
        };
        window.addEventListener('managerViewTypeChanged', syncViewType);
        window.addEventListener('storage', syncViewType);
        return () => {
            window.removeEventListener('managerViewTypeChanged', syncViewType);
            window.removeEventListener('storage', syncViewType);
        };
    }, []);

    const BASE_URL = process.env.REACT_APP_BASE_URL;

    // Check if user has an admin level assigned
    const hasAdminLevel = () => {
        try {
            const adminLevelData = localStorage.getItem('adminLevel');
            if (adminLevelData) {
                const adminLevel = JSON.parse(adminLevelData);
                return adminLevel && (adminLevel.modules?.length > 0 || adminLevel.adminLevelId);
            }
        } catch (e) {
            console.error('Error checking admin level:', e);
        }
        return false;
    };

    // Fetch dashboard metrics
    useMetricsFetch({
        BASE_URL,
        viewType,
        hasAdminLevel,
        setEmployeeCount,
        setCounts,
        setDepartmentStats,
    });

    // Ù…Ø¹Ù„ÙˆÙ…Ø§Øª Ø§Ù„Ù…Ø³ØªØ®Ø¯Ù… Ù…Ù† localStorage
    const [user] = useState({
        username: localStorage.getItem("emoloyeeName"),
        email: localStorage.getItem("email"),
        role: localStorage.getItem("role"),
    });

    const [notifications, setNotifications] = useState(3);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [currentPage, setCurrentPage] = useState('dashboard');

    // Call hooks at top level
    const navigate = useNavigate();
    const auth = useAuth();
    const { conversations: messengerConversations, socket, isConnected } = useMessenger();
    const { logout, hasModuleAccess, permissions } = auth;
    const { showModal } = useModal();

    // Unread messages hook
    const { unreadMessages } = useUnreadMessages({
        BASE_URL,
        socket,
        isConnected,
        messengerConversations,
    });

    // Module permissions hook
    const { modulePermissions } = useModulePermissions(BASE_URL);

    // "Communicator Module (PTT & Private Messages)" is the umbrella toggle a
    // superadmin actually reaches for in Communication Modules — it wasn't
    // wired to anything, so flipping it left the Messenger page locked unless
    // the separate, easy-to-miss "Private Messaging" sub-toggle was ALSO set.
    const isPrivateMessagingEnabled =
      (modulePermissions?.privateMessaging || modulePermissions?.communicatorModule) ?? false;

    // Reset currentPage when the view type CHANGES.
    //
    // Skips the very first run: on mount the URL is the source of truth (a
    // reload or a deep link lands straight on a page), and stomping
    // currentPage here just made this effect fight useSyncPageWithRoute over
    // the same state.
    const previousViewType = useRef(null);
    useEffect(() => {
        const changed = previousViewType.current !== null && previousViewType.current !== viewType;
        previousViewType.current = viewType;
        if (changed) setCurrentPage(defaultPageFor(viewType));

        if (viewType === 'admin') {
            console.log('ðŸ” Admin View Mode Active');
            console.log('Admin Level Data (raw):', localStorage.getItem('adminLevel'));
            try {
                const adminLevel = JSON.parse(localStorage.getItem('adminLevel'));
                console.log('Parsed Admin Level:', adminLevel);
                console.log('Available Modules:', adminLevel?.modules);
                console.log('Module names:', adminLevel?.modules?.map(m => m.moduleName || m.name || m));
            } catch (e) {
                console.error('Error parsing adminLevel:', e);
            }

            console.log('AuthContext permissions:', auth.permissions);
            console.log('AuthContext user:', auth.user);
        }
        // `auth` is deliberately NOT a dependency. This effect exists to reset
        // the page when the VIEW TYPE changes -- that is what its name says and
        // all it should ever do. But AuthContext builds its provider value as an
        // inline object literal, so `useAuth()` hands back a brand-new identity
        // on every single AuthProvider render. Listing `auth` here therefore
        // fired "reset to dashboard" on completely unrelated auth updates,
        // including the permission refresh that happens as a newly-opened page
        // mounts. Clicking Employees navigated correctly and was then snapped
        // back to the dashboard by this effect a tick later.
        //
        // The two `auth.*` reads below are debug logging only, so they are safe
        // to leave reading the latest value without subscribing to it.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [viewType]);

    const handleViewTypeChange = (type) => {
        try {
            if (type) {
                localStorage.setItem('managerViewType', type);
                localStorage.setItem('viewType', type);
            }
        } catch (error) {
            console.warn('Failed to persist view type selection:', error);
        }

        if (type === 'user') {
            // Navigating away from this page entirely — skip setViewType so the
            // sidebar here doesn't re-render (filtered down to 2 items) before
            // the router swaps in the user profile page.
            if (hasAdminLevel() && user.role === 'admin') {
                navigate("/userprofileadmin/professionalProfile");
            } else {
                navigate("/userprofilemanager/professionalProfile");
            }
            return;
        }

        setViewType(type);

        // Land on whatever the TARGET view's sidebar actually begins with,
        // and navigate there.
        //
        // Two things were wrong before. It hard-coded 'dashboard', which is an
        // assumption about the sidebar rather than a reading of it; and the
        // 'manager' branch set currentPage WITHOUT navigating, so the URL kept
        // pointing at the previous view's page and the router happily kept
        // rendering it while the sidebar highlight said otherwise.
        const landingPage = defaultPageFor(type);
        setCurrentPage(landingPage);
        navigate(`/DashboardManager/${landingPage}`);
    };

    // Ø§Ù„ØªØ¨Ø¯ÙŠÙ„ Ø¨ÙŠÙ† Ø§Ù„Ø«ÙŠÙ… Ø§Ù„ÙØ§ØªØ­ ÙˆØ§Ù„Ø¯Ø§ÙƒÙ†
    const toggleTheme = () => {
        const newTheme = theme === "light" ? "dark" : "light";
        setTheme(newTheme);
    };

    // Ø¯Ø§Ù„Ø© ØªØ³Ø¬ÙŠÙ„ Ø§Ù„Ø®Ø±ÙˆØ¬
    const handleLogout = () => {
        try {
            logout();
            try {
                localStorage.removeItem('nav_admin');
                localStorage.removeItem('nav_manager');
                localStorage.removeItem('nav_employee');
            } catch (e) { }
            navigate("/login");
        } catch (error) {
            console.error("Ø®Ø·Ø£ ÙÙŠ ØªØ³Ø¬ÙŠÙ„ Ø§Ù„Ø®Ø±ÙˆØ¬:", error);
            navigate("/login");
        }
    };

    // Ø§Ù„ØªØ¨Ø¯ÙŠÙ„ Ø¥Ù„Ù‰ Ø­Ø³Ø§Ø¨ Ø§Ù„Ù…ÙˆØ¸Ù
    const handleSwitchEmployee = () => {
        try {
            localStorage.removeItem('adminCurrentPage');
            setCurrentPage('dashboard');
            navigate("/userprofilemanager/professionalProfile");
        } catch (error) {
            console.error("Ø®Ø·Ø£ ÙÙŠ Ø§Ù„ØªØ¨Ø¯ÙŠÙ„:", error);
            navigate("/DashboardManager");
        }
    };

    // Ø¹Ù†Ø§ØµØ± Ù‚Ø§Ø¦Ù…Ø© Ø§Ù„ØªÙ†Ù‚Ù„
    //
    // Memoized because useSyncPageWithRoute takes it as a dependency. Rebuilt
    // inline it was a new array on every render, so that hook's effect re-ran
    // after every render and raced the reset effect above over currentPage.
    const allNavItems = useMemo(() => [
        { icon: Home, text: t.dashboard, page: "dashboard" },
        { icon: Users, text: t.employees, page: "employees" },
        { icon: Clock, text: t.attendance, page: "attendance" },
        { icon: CalendarIcon, text: t.calendar, page: "calendar" },
        {
            icon: MessageSquare,
            text: isPrivateMessagingEnabled ? t.messages : t.messagesLocked,
            page: "messages",
            locked: !isPrivateMessagingEnabled,
            badge: unreadMessages,
            badgeColor: '#ef4444',
        },
        { icon: BookCheckIcon, text: t.documentsManagement, page: "DocumentsManagement" },
        { icon: Coffee, text: t.leaveManagement, page: "LeaveApprovalPage" },
        { icon: DollarSignIcon, text: t.solfaManagement, page: "AdvancementsManagement" },
        { icon: GitPullRequestIcon, text: t.employeeChanges, page: "ChangesPage" },
        { icon: CreditCard, text: t.payroll, page: "Payroll" },
        { icon: CalculatorIcon, text: t.taxCalculator, page: "TaxCalculator" },
        { icon: LockIcon, text: t.companyConfiguration, page: "companyConfig" },
        { icon: Settings, text: t.settingsLocked, page: "Settings" },
    ], [t, isPrivateMessagingEnabled, unreadMessages]);

    // ØªØºÙŠÙŠØ± Ø§Ù„ØµÙØ­Ø© Ø§Ù„Ø­Ø§Ù„ÙŠØ©
    const handlePageChange = (page) => {
        const navItem = navItems.find(item => item.page === page);
        if (navItem?.locked) {
            const title = (t && t.notice) || 'Notice';
            const message = navItem.lockMessage || undefined;
            showModal({ title, message, options: { requestAccessEndpoint: process.env.REACT_APP_BASE_URL ? `${process.env.REACT_APP_BASE_URL}/api/request-module-access` : null, module: navItem.page } });
            return;
        }
        setCurrentPage(page);
        navigate(`/DashboardManager/${page}`);
    };

    // Sync currentPage with URL
    useSyncPageWithRoute({ allNavItems, currentPage, setCurrentPage });

    // Which nav items a given view may see. Taking `view` as an argument
    // (rather than closing over the current `viewType`) is what lets
    // handleViewTypeChange below ask "what will the sidebar look like AFTER
    // this switch?" and land on a page that will actually be there.
    // Dashboard and Settings are DEFAULT-ON: the permission registry documents
    // that "a level with no explicit dashboard row still resolves to
    // VISIBLE_ACCESSIBLE with no features" — the promoted account gets the
    // plain dashboard (visibility-scoped KPI tiles) and each granted feature
    // unlocks one more card. So an account holding only `employees` seeing the
    // dashboard is the intended behaviour, not a leak.
    //
    // What the registry ALSO says is that "an explicit HIDDEN row removes the
    // page entirely" — and that half could never happen here, because the two
    // pages were hard-returned as visible before any check ran. This reads the
    // explicit state and honours it, while leaving the default untouched.
    //
    // Only `permissions.pages` is consulted, never modules[]: an absent key
    // means "no explicit decision", which is exactly the default-on case. Real
    // admins and every non-admin view are unaffected — this only applies to an
    // account browsing Admin View on an admin level.
    const isExplicitlyHidden = (pageKey, view) => {
        if (view !== 'admin') return false;
        if (user.role === 'admin' || user.role === 'superadmin') return false;
        const state = permissions?.pages?.[pageKey];
        return state === 'HIDDEN';
    };

    const visibleNavItemsFor = (view) => allNavItems.filter(item => {
        if (item.page === "dashboard" || item.page === "Settings") {
            return !isExplicitlyHidden(item.page, view);
        }
        if (user.role === "superadmin") return true;
        if (adminOnlyPages.includes(item.page) && (view === 'user' || view === 'manager')) {
            return false;
        }
        if (view === 'user') return false;
        if (view === 'manager') return !adminOnlyPages.includes(item.page);
        if (view === 'admin') {
            const requiredModule = pageToModuleMap[item.page];
            if (!requiredModule) return true;
            return hasModuleAccess(requiredModule);
        }
        return true;
    });

    // Filter navigation items based on viewType
    const navItems = visibleNavItemsFor(viewType);

    // The page a view should open on: simply the first entry of its own
    // sidebar. This used to be the hard-coded string 'dashboard', which is an
    // assumption about the sidebar's contents rather than a fact about it --
    // if a view's first item is ever something else, the shell would land on a
    // page the sidebar isn't even pointing at.
    const defaultPageFor = (view) => visibleNavItemsFor(view)[0]?.page || 'dashboard';

    // ---- render helpers ----
    const renderDashboard = () => (
        <Dashboard employeeCount={employeeCount} counts={counts} departmentStats={departmentStats} viewType={viewType} />
    );
    const renderEmployees = () => {
        if (viewType === 'admin') return <EmployeesTableadmin />;
        return (
            <EmployeesTable
                onCountsUpdate={(updatedCounts) => {
                    if (updatedCounts && typeof updatedCounts === "object") {
                        setCounts((prev) => ({ ...prev, ...updatedCounts }));
                    }
                }}
                onEmployeeCountUpdate={(total) => {
                    if (typeof total === "number") setEmployeeCount(total);
                }}
            />
        );
    };
    const renderAttendance = () => <Attendance />;
    const renderAnalytics = () => <Analytics />;
    const renderReports = () => <Reports />;
    const renderCalendar = () => <Calendar />;
    const renderSettings = () => <SettingsPage />;
    const renderMo3tiAdminDocumentRequests = () => <Mo3tiAdminDocumentRequests />;
    const renderMo3tiAdvancementManagement = () => <Mo3tiAdvancementManagement />;
    const renderAdminLeavePage = () => <LeaveApprovalPage />;
    const renderChangesPage = () => <EmployeeActionsPage />;
    const renderPayroll = () => <Payroll />;
    const renderTaxCalculator = () => <ExcelSalaryProcessorWithTheme />;
    const renderCompanyConfig = () => <CompanyConfiguration />;

    // Ø§Ù„Ø¹Ø±Ø¶ Ø§Ù„Ø±Ø¦ÙŠØ³ÙŠ
    return (
        <div
            style={{
                minHeight: "100vh",
                fontFamily: "Segoe UI, Roboto, sans-serif",
                position: "relative",
                direction: isRTL ? "rtl" : "ltr",
            }}
        >
            <BackgroundBlobs theme={theme} />

            <SidebarWithTopbar
                navItems={navItems}
                currentPage={currentPage}
                handlePageChange={handlePageChange}
                user={user}
                notifications={notifications}
                handleLogout={handleLogout}
                handleSwitchEmployee={handleSwitchEmployee}
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
                themeToggle={
                    <button
                        style={{
                            padding: "8px",
                            borderRadius: "12px",
                            cursor: "pointer",
                            color: theme === "light" ? "#0f172a" : "white",
                            background: theme === "light" ? "rgba(0,0,0,0.1)" : "rgba(255,255,255,0.1)",
                        }}
                        onClick={toggleTheme}
                    >
                        {theme === "light" ? <Moon size={20} /> : <Sun size={20} />}
                    </button>
                }
                viewModeSwitcher={
                    <ViewTypeSwitcher
                        viewType={viewType}
                        onSelect={(type) => handleViewTypeChange(type)}
                        hasAdminLevel={() => hasAdminLevel()}
                        role={user.role}
                    />
                }
            >
                <div style={{
                    padding: "0",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    marginTop: currentPage === 'messages' ? '0' : '40px',
                    direction: isRTL ? "rtl" : "ltr",
                }}>
                    <Routes>
                        <Route path="/dashboard" element={renderDashboard()} />
                        <Route path="/employees" element={renderEmployees()} />
                        <Route path="/attendance" element={renderAttendance()} />
                        <Route path="/analytics" element={renderAnalytics()} />
                        <Route path="/reports" element={renderReports()} />
                        <Route path="/calendar" element={renderCalendar()} />
                        <Route
                            path="/messages"
                            element={
                                modulePermissions === null ? (
                                    <div style={{ padding: 20, textAlign: "center" }}>Loading...</div>
                                ) : isPrivateMessagingEnabled ? (
                                    <MessengerPage />
                                ) : (
                                    <Navigate to="/DashboardManager/dashboard" replace />
                                )
                            }
                        />
                        <Route path="/documentsmanagement" element={renderMo3tiAdminDocumentRequests()} />
                        <Route path="/advancementsmanagement" element={renderMo3tiAdvancementManagement()} />
                        <Route path="/Payroll" element={renderPayroll()} />
                        <Route path="/TaxCalculator" element={renderTaxCalculator()} />
                        <Route path="/LeaveApprovalPage" element={renderAdminLeavePage()} />
                        <Route path="/ChangesPage" element={renderChangesPage()} />
                        <Route path="/companyConfig" element={renderCompanyConfig()} />
                        <Route path="/Settings" element={renderSettings()} />
                        <Route path="*" element={<Navigate to="/DashboardManager" replace />} />
                    </Routes>
                </div>
            </SidebarWithTopbar>
        </div>
    );
}

export default ProfessionalDashboardManager;